import axios from 'axios';
import type { LinkPreviewMedia } from '@/server/services/LinkPreview/LinkPreview.types';
import { Env } from '@/utils/env';
import { copilot } from './api.copilot';
import { copilotGiActions } from './api.copilot.giActions';
import { dashboard } from './api.dashboard';
import { embeddedApps } from './api.embeddedApps';
import { geopoliticalActions } from './api.geopolitical-actions';
import { incidents } from './api.incidents';
import { mapEvents } from './api.map-events';
import { media } from './api.media';
import { narratives } from './api.narratives';
import { payments } from './api.payments';
import { reports } from './api.reports';
import { trade } from './api.trade';
import { user } from './api.user';
import { AxiosError, ROUTE, axiosInstance, isAxiosError, isCancel } from './axiosInstance';

export type { AxiosError };

if (Env.isDev() && typeof window !== 'undefined') {
  Object.assign(window, { axios });
}

type AppVersion = {
  buildId: string;
  timestamp: string;
  GITHUB_SHA: string;
  GITHUB_RUN_ID: string;
  GITHUB_RUN_NUMBER: string;
};

export const Api = {
  get: axiosInstance.get,
  post: axiosInstance.post,
  put: axiosInstance.put,
  delete: axiosInstance.delete,

  isAxiosError,
  isCancel,

  dashboard,
  copilot,
  copilotGiActions,
  mapEvents,
  media,
  reports,
  narratives,
  user,
  trade,
  geopoliticalActions,
  payments,
  incidents,
  embeddedApps,

  getLinkPreviewMedia: async (args: { link: string }) => {
    const { data } = await axiosInstance.get<LinkPreviewMedia>(ROUTE.LINK_PREVIEW_MEDIA, {
      params: { link: args.link },
    });
    return data;
  },

  appVersion: async () => {
    const data = await axios
      .get<AppVersion>(`/version.txt?timestamp=${Date.now()}`)
      .then((resp) => resp.data)
      .catch((err) => ({}));

    const buildId = typeof window !== 'undefined' ? window.__NEXT_DATA__?.buildId : '';
    return { ...data, buildId };
  },
};
